var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9006_128603)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8.161 3.448 3.393 5.876 1.228 2.127a.62.62 0 0 1 0 .64.62.62 0 0 1-.553.319H4.094a.62.62 0 0 1-.553-.32.62.62 0 0 1 0-.639L4.77 9.324z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m1.48 6.084 7.735 6.326H3.397a.63.63 0 0 1-.624-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.453 2.866a1.322 1.322 0 1 0-2.643.021 1.322 1.322 0 0 0 2.643-.021"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.727 6.084 6.992 12.41h5.818a.63.63 0 0 0 .624-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.989 5.75a1.322 1.322 0 1 0-2.644.021 1.322 1.322 0 0 0 2.643-.022M2.656 5.732a1.322 1.322 0 1 0-2.643.021 1.322 1.322 0 0 0 2.643-.021"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19 13.189h9.813a.32.32 0 0 1 .32.319v.62a.32.32 0 0 1-.32.319H3.191a.32.32 0 0 1-.32-.32v-.62a.32.32 0 0 1 .32-.319"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9006_128603"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.5040ae8fd0fbb49a5087afb1a0cfc59f.svg";
export { ForwardRef as ReactComponent };